import axios from "../axios";

const api = {
  createQuestionnaire(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/organization-questionnaires", data, headers).then(({ data }) => data);
  },

  updateQuestionnaire({ id, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/organization-questionnaires/${id}`, data, headers).then(({ data }) => data);
  },

  getQuestionnaireById(id, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/organization-questionnaires/${id}`, headers).then(({ data }) => data);
  },

  getAllQuestionnaires(queryParams, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires?${queryParams}`, config).then(({ data }) => data);
  },

  deleteQuestionnaire(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/organization-questionnaires/${id}`, headers).then(({ data }) => data);
  },

  finalizeQuestionnaire(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${id}/finalize`, id, headers).then(({ data }) => data);
  },

  importScopeOneAndTwoData({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/import`, data, headers).then(({ data }) => data);
  },

  getOrganisationQuestionnaires(params, accessToken) {
    const config = {
      params: params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/organization-questionnaires-data", config).then(({ data }) => data);
  },

  getQuestionnaireDataById(id, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/organization-questionnaires-data/${id}`, headers).then(({ data }) => data);
  },

  unfinaliseOrgQuestionnaire(questionnaireId, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.patch(`/organization-questionnaires/${questionnaireId}/unfinalize`, {}, headers).then(({ data }) => data);
  },

  downloadScopeOneTemplate(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/scope-one/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "Scope_One_template";
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  },

  downloadScopeTwoTemplate(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/scope-two/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "Scope_Two_template";
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }

};

export default api;
